import { config } from '../config/config'

function findRemoteFunc(list, funcList, tokenFuncList, blankList) {
  for (let i = 0; i < list.length; i++) {
    if (list[i].type === 'grid') {
      list[i].columns.forEach(item => {
        findRemoteFunc(item.list, funcList, tokenFuncList, blankList)
      })
    } else {
      if (list[i].type === 'blank') {
        if (list[i].model) {
          blankList.push({
            name: list[i].model,
            label: list[i].name,
          })
        }
      } else if (list[i].type === 'imgupload') {
        if (list[i].options.tokenFunc) {
          tokenFuncList.push({
            func: list[i].options.tokenFunc,
            label: list[i].name,
            model: list[i].model,
          })
        }
      } else {
        if (list[i].options.remote && list[i].options.remoteFunc) {
          funcList.push({
            func: list[i].options.remoteFunc,
            label: list[i].name,
            model: list[i].model,
          })
        }
      }
    }
  }
}

export default function (data) {
  const funcList = []

  const tokenFuncList = []

  const blankList = []

  findRemoteFunc(JSON.parse(data).list, funcList, tokenFuncList, blankList)

  let funcTemplate = ''

  let blankTemplate = ''

  for (let i = 0; i < funcList.length; i++) {
    funcTemplate += `
            ${funcList[i].func} (resolve) {
              // ${funcList[i].label} ${funcList[i].model}
              // 获取到远端数据后执行回调函数
              // resolve(data)
            },
    `
  }

  for (let i = 0; i < tokenFuncList.length; i++) {
    funcTemplate += `
            ${tokenFuncList[i].func} (resolve) {
              // ${tokenFuncList[i].label} ${tokenFuncList[i].model}
              // 获取到token数据后执行回调函数
              // resolve(token)
            },
    `
  }

  for (let i = 0; i < blankList.length; i++) {
    blankTemplate += `
        <template slot="${blankList[i].name}" slot-scope="scope">
          <!-- ${blankList[i].label} -->
          <!-- 通过 v-model="scope.model.${blankList[i].name}" 绑定数据 -->
        </template>
    `
  }

  return `<!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width,initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
    <link rel="stylesheet" href="https://unpkg.com/element-ui@2.10.1/lib/theme-chalk/index.css">
    <link rel="stylesheet" href="${config.baseAPI}/static/SwFormMaking.css">
  </head>
  <body>
    <div id="app" style="width: 96%;padding-left: 2%">
     <!-- <button-list class="sw-bn-list" ref="swBnDiv">
      </button-list>-->
      <fm-generate-form :style="swFormHeight" :remote="remoteFuncs" :value="editData"
        :fid="fid" :ffid="ffid" :task-id="taskId" :form-data-id="id" :form-data-version="version" :current-user="currentUser" ref="generateForm"> <!-- :data="jsonData" -->
        ${blankTemplate}
      </fm-generate-form>
    </div>
    <script src="https://unpkg.com/vue@2.6.10/dist/vue.js"></script>
    <script src="https://unpkg.com/element-ui@2.10.1/lib/index.js"></script>
    <script src="${config.baseAPI}/static/SwFormMaking.umd.js"></script>
    <script src="${config.baseAPI}/static/lib/utils.js"></script>
    <script>
      const formId = getQueryVariable("id")
      const formVersion = getQueryVariable("version")
      const fid1 = getQueryVariable("fid")
      const ffid1= getQueryVariable("ffid")
      const taskId1= getQueryVariable("taskId")
      let currentUser1 = {}
      if(typeof(backUserId)!=="undefined" &&  backUserId && typeof(backUserName)!=="undefined" && backUserName && typeof(backRealName)!=="undefined" &&  backRealName){
      currentUser1 = { // 当前登录用户
           userId: backUserId,
           username: backUserName,
           realName: backRealName
      }
   }
      var vm = new Vue({
        el: '#app',
        data: {
          id: formId,
          version: formVersion,
          fid: fid1,
          ffid: ffid1,
          taskId: taskId1,
          jsonData: ${data},
          editData: {},
          currentUser:currentUser1,
          remoteFuncs: {
            ${funcTemplate}
          },
          swFormHeight: { marginTop: '0px'}
        },
        methods: {
        }
      })
    </script>
    <style>
      .sw-bn-list{
        background-color: #b2bac170;
        position: fixed;
        z-index: 81;
        top: 0px;
        width: 100%;
      }
  </style>
  </body>
  </html>`
}
